// extracted by mini-css-extract-plugin
export var chevronIcon = "_4h-2";
export var teamName = "_4h-1";
export var teamSwitcherButton = "_4h-0";